import { makeAutoObservable } from "mobx"

import { AnswerCitationDetails } from "@services/search.service"

export class SearchAnswersContextStore {
  // injections

  // constructor

  constructor() {
    this.contextData = new Map()

    makeAutoObservable(this)
  }

  // state

  contextData: Map<string, AnswerCitationDetails>

  get getAnswerById() {
    const { contextData } = this
    return (citationId: string) => contextData.get(citationId)
  }

  // actions

  addCitationContext = (data: AnswerCitationDetails[]) => {
    data.forEach((it) => {
      this.contextData.set(it.citationId, it)
    })
  }
}

export default SearchAnswersContextStore
